// JsFromRoutes CacheKey a539ecf94e2e78bc97602412514311ee
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@consumer/services/api'

export default {
  index: /* #__PURE__ */ definePathHelper('get', '/consumer/calendar/event_instances'),
  show: /* #__PURE__ */ definePathHelper('get', '/consumer/calendar/event_instances/:id'),
}
